export class LoadingSheetDto {

    loadingSheetId: number;
    lotNumber:number;
    loadingSheetNumber: number;
    variety:string;
    grade: string;
    count: number;
    saleOrderId: number;
    
    constructor(
        loadingSheetId:number,
        lotNumber:number,
        loadingSheetNumber:number,
        variety:string,
        grade:string,
        count:number,
        saleOrderId:number,
    
            )
            {
           this.loadingSheetId=loadingSheetId
           this.lotNumber=lotNumber
           this.loadingSheetNumber=loadingSheetNumber    
           this.variety=variety
           this.grade=grade
           this.count=count
           this.saleOrderId=saleOrderId
        }
}

